<template>
    <label>
        <span class="constant">{{constantValue}}</span>
        <input :value="defaultValue"
               @change="$emit('change',$event.target.value)"
               @input="$emit('input',$event.target.value)"
               autocapitalize="off"
               autocomplete="off"
               spellcheck="false"
               type="text">
    </label>
</template>

<script>
    export default {
        name: 'EndLinkInput',
        props: {
            defaultValue: String,
            constantValue: {
                type: String,
                required: true
            }
        }
    };
</script>

<style scoped>
    label {
        background-color: #ffffff11;
        display: flex;
        border-radius: 4px;
        color: white;
        margin: 4px;
        font-size: .9em;
        /*border: 1px solid #ffffff33;*/
    }

    span {
        border: 1px solid #ffffff33;
        border-right-width: 0;
        padding: 8px 2px 8px 8px;
        opacity: .7;
        box-sizing: border-box;
        overflow-x: hidden;
        text-overflow: ellipsis;
        flex-grow: 2;

        border-radius: 4px 0 0 4px;
    }

    input {
        flex-grow: 1;
        box-sizing: border-box;
        padding: 8px 8px 8px 2px;
        font-size: 1em;
        background: none;
        color: white;
        min-width: 0;
        opacity: .9;
        border: 1px solid #ffffff33;
        border-radius: 0 4px 4px 0;
        transition: border-color .3s;
    }

    input:focus {
        outline: none;
        border-color: #4646bd;
    }
</style>

